import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Platform, ScrollView, StyleSheet, Text, View } from 'react-native';
import { SafeAreaInsetsContext } from 'react-native-safe-area-context';

import Colors from '../../constants/Colors';
import Languages from '../../constants/Languages';
import Layout from '../../constants/Layout';
import * as Actions from '../../store/Actions';
import Header from '../../components/register/Header';
import FilledButton from '../../components/FilledButton';
import MyFloatingLabelInput from '../../components/form/MyFloatingLabelInput';

class ResetPasswordScreen extends Component {
  static propTypes = {
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super();
    const { registration } = props;
    let email = '';
    if (get(registration, 'emailOrPhoneResult.email')) {
      email = registration.emailOrPhoneResult.email;
    } else if (get(registration, 'enterEmail.results.email')) {
      email = registration.enterEmail.results.email;
    }
    this.state = {
      email,
      isValid: this.validate(email),
      spacerHeight: 200,
    };
  }

  validate = (value) => {
    if (!value) return false;
    if (value.indexOf('@') !== -1 && value.indexOf('.') !== -1 && value.indexOf('.') < value.length - 2)
      return true;
  };

  goBack = () => {
    const { navigation } = this.props;
    navigation.navigate('EnterPassword');
  };

  goNext = () => {
    const { actions, navigation } = this.props;
    const { email } = this.state;

    actions.resetPassword(email, () => {
      navigation.navigate('ResetPasswordSent');
    });
  };

  onUpdateText = (text) => {
    const { actions, registration } = this.props;
    const { enterEmail } = registration;
    if (enterEmail.error) actions.clearEnterEmailError();
    const value = text.trim();
    const isValid = this.validate(value);
    this.setState({ email: value, isValid, emailError: null });
  };

  goToAnotherWay = () => {
    const { navigation } = this.props;
    navigation.navigate('PhoneOrEmail');
  };

  onFocus = () => {
    if (Layout.isSmall) {
      this.setState({ spacerHeight: 0 });
    }
  };

  onBlur = () => {
    if (Layout.isSmall) {
      this.setState({ spacerHeight: 200 });
    }
  };

  render() {
    const { registration } = this.props;
    const { email, isValid, spacerHeight } = this.state;
    const { language } = registration;
    const translation = Languages.translations[language?.name || 'en'];

    const dStyles = StyleSheet.create({
      spacerContainer: {
        height: spacerHeight,
      },
    });

    return (
      <SafeAreaInsetsContext.Consumer>
        {(insets) => (
          <ScrollView
            keyboardShouldPersistTaps="handled"
            contentContainerStyle={styles.mainContentContainer}
            extraScrollHeight={172}
            style={[
              styles.container,
              {
                paddingTop: insets.top,
              },
            ]}
            testID="reset-password"
          >
            <Header title={translation.reset_password} goBack={this.goBack} />
            <View style={styles.signupContainer}>
              <View style={styles.topContainer}>
                <View style={styles.emailContainer}>
                  <Text style={styles.headingText}>{translation.reset_password_text}</Text>
                  <View style={styles.form}>
                    <Text>{translation.reset_email_text}</Text>
                    <MyFloatingLabelInput
                      label={translation.email_address}
                      style={styles.input}
                      onChangeText={this.onUpdateText}
                      onSubmitEditing={this.goNext}
                      onFocus={this.onFocus}
                      onBlur={this.onBlur}
                      keyboardType="email-address"
                      value={email}
                      width={328}
                      testID="email"
                    />
                  </View>
                </View>
              </View>
              <View style={dStyles.spacerContainer} />
              <View style={styles.submitContainer}>
                <FilledButton
                  onPress={this.goNext}
                  label={translation.submit}
                  color={Colors.primaryColor}
                  full
                  textColor={Colors.white}
                  disabled={!isValid}
                  testID="button-submit"
                />
                <View style={styles.linkContainer}>
                  <Text onPress={this.goToAnotherWay} style={styles.linkText}>
                    {translation.sign_in_another_way}
                  </Text>
                </View>
              </View>
            </View>
          </ScrollView>
        )}
      </SafeAreaInsetsContext.Consumer>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.mediumBlue,
  },
  mainContentContainer: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: Colors.white,
  },
  topContainer: {
    alignItems: 'center',
  },
  emailContainer: {
    width: 328,
    marginTop: Layout.isSmall ? 80 : 100,
  },
  headingText: {
    fontSize: Layout.isSmall ? 20 : 26,
    fontWeight: '500',
    color: Colors.veryDarkGray,
    fontFamily: 'roboto-regular',
    textAlign: 'center',
    marginTop: Layout.isSmall ? 53 : 34,
  },
  form: {
    marginBottom: 16,
    padding: 0,
    paddingTop: 16,
    width: 345,
  },
  input: {
    marginTop: 49,
    fontSize: 16,
    lineHeight: 24,
    fontFamily: 'roboto-regular',
  },
  signupContainer: {
    flex: 1,
    alignItems: 'center',
    paddingBottom: 200,
  },
  submitContainer: {
    marginBottom: 60,
    width: 328,
    alignItems: 'center',
  },
  linkContainer: {
    paddingHorizontal: 16,
    paddingTop: Layout.isSmall ? 20 : 32,
    paddingBottom: 6,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: Layout.isSmall ? 'row' : 'column',
  },
  linkText: {
    fontSize: Layout.isSmall ? 14 : 16,
    marginBottom: 24,
    color: Colors.darkGreen,
    textDecorationLine: 'underline',
    textTransform: 'uppercase',
    fontWeight: '500',
  },
});

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordScreen);
